import { SUMMARY_LABELS } from 'modules/WorkTime/static_data';
import { returnLeaveDays } from 'utils/helpers';

interface SummaryCategoryResponse {
  serviceBreaks?: string[];
}

// Service break dates, when the summary response provides them.
export const getSummaryCategoryDays = (response: SummaryCategoryResponse) =>
  Array.isArray(response.serviceBreaks)
    ? { serviceBreaks: returnLeaveDays(response.serviceBreaks) }
    : {};

// B2B and civil-contract consultants see only "Service break"; they report no
// days off, so legacy DAY_OFF dates are not shown to them.
export const isSummaryRowVisible = (
  key: string,
  userContract?: string,
  hasSplitCategories = false,
) =>
  userContract === 'EMPLOYMENT_CONTRACT'
    ? key !== 'serviceBreaks'
    : !(key === 'daysOff' && hasSplitCategories);

export const getSummaryRowLabel = (
  key: string,
  userContract: string | undefined,
  hasSplitCategories: boolean,
) =>
  key === 'daysOff' &&
  userContract !== 'EMPLOYMENT_CONTRACT' &&
  !hasSplitCategories
    ? 'SUMMARY.SERVICE_BREAKS'
    : SUMMARY_LABELS[key];
